import { api } from "../../../api/Middleware";
import {
  ONBOARDING_STATUS_URL,
  ONBOARDING_COMPLETE_URL,
  ONBOARDING_SKIP_URL,
  ONBOARDING_ANALYTICS_URL,
  ONBOARDING_RESET_URL,
} from "../../../api/Urls";

// ===============================================
// ONBOARDING SERVICE
// ===============================================

const OnboardingService = {
  // Obter status do onboarding do usuario
  getStatus: async () => {
    try {
      const response = await api.get(ONBOARDING_STATUS_URL);
      return response.data;
    } catch (error) {
      // Se 404, significa que o usuario nunca fez onboarding
      if (error.response?.status === 404) {
        return { completed: false, skipped: false, current_step: 0 };
      }
      console.error("Error fetching onboarding status:", error);
      throw error;
    }
  },

  // Marcar onboarding como completo
  complete: async (analyticsData = {}) => {
    try {
      const response = await api.post(ONBOARDING_COMPLETE_URL, analyticsData);
      return response.data;
    } catch (error) {
      console.error("Error completing onboarding:", error);
      throw error;
    }
  },

  // Pular onboarding
  skip: async (skipData = {}) => {
    try {
      const response = await api.post(ONBOARDING_SKIP_URL, skipData);
      return response.data;
    } catch (error) {
      console.error("Error skipping onboarding:", error);
      throw error;
    }
  },

  // Enviar analytics de interacao
  trackAnalytics: async (eventData) => {
    try {
      const response = await api.post(ONBOARDING_ANALYTICS_URL, eventData);
      return response.data;
    } catch (error) {
      // Analytics silencioso - nao deve bloquear o fluxo
      console.warn("Error tracking onboarding analytics:", error);
      return null;
    }
  },

  // Resetar onboarding (para rever o guia)
  reset: async () => {
    try {
      const response = await api.post(ONBOARDING_RESET_URL);
      return response.data;
    } catch (error) {
      console.error("Error resetting onboarding:", error);
      throw error;
    }
  },
};

export default OnboardingService;
